import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import DeleteActionButton from '../../../../../components/designe/ActionButtons/DeleteActionButton';
import EditActionButton from '../../../../../components/designe/ActionButtons/EditActionButton';
import AppProgramCollectionAvatar from '../../../../../components/designe/app-entity-avatar/app-program-collection-avatar/AppProgramCollectionAvatar';
import ConfirmDialog from '../../../../../components/reusable/confirm-dialog/ConfirmDialog';
import { useNavigationStack } from '../../../../../context/NavigationStackContext';
import { useDeletePrograms } from '../../../../../redux/api/programsAPI';
import { AvatarSize } from '../../../../../shared/constants';
import { Paths } from '../../../../../shared/paths';
import { IProgramCollection } from '../../../../../types/interfaces/program-collection';
import { useStyles } from './ProgramCollectionListItem.styles';

interface IProgramListItemProps {
  programCollection: IProgramCollection;
  onItemClick: (p: IProgramCollection) => void;
}

const ProgramCollectionListItem = (props: IProgramListItemProps) => {
  const { programCollection, onItemClick } = props;
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const { t } = useTranslation();
  const [deleteProgram] = useDeletePrograms();
  const { navigate } = useNavigationStack();
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <div className={classes.programCollectionWrapper}>
      <div
        className={classes.programCollectionHeader}
        onClick={() => onItemClick(programCollection)}>
        <div className={classes.programCollectionInfoWrapper}>
          <AppProgramCollectionAvatar
            programCollection={programCollection}
            size={AvatarSize.m}
          />
          <div className={classes.programInfoWrapper}>
            <Typography variant="h3">{programCollection.title}</Typography>
          </div>
        </div>
      </div>

      <Box
        display="flex"
        alignItems="flex-start"
        gap={1}
        flexShrink={0}
        onClick={(e) => e.stopPropagation()}>
        {programCollection?.permissions?.canEdit && (
          <EditActionButton
            onClick={(e) =>
              navigate(Paths.programs.toEditCollectionId(programCollection.id))
            }
          />
        )}
        {programCollection?.permissions?.canDelete && (
          <DeleteActionButton onClick={(e) => setDeleteConfirm(true)} />
        )}
      </Box>

      <div onClick={(e) => e.stopPropagation()}>
        <ConfirmDialog
          open={!!deleteConfirm}
          onClose={() => setDeleteConfirm(null)}
          title={t('common.delete')}
          onSubmit={() => deleteProgram({ id: programCollection.id })}>
          {t('common.deleteQuestion')}
        </ConfirmDialog>
      </div>
    </div>
  );
};

export default ProgramCollectionListItem;
